module.exports = __webpack_public_path__ + "static/media/restaurant-pin.495d5855.svg";